// Shared style tokens for a compact, professional look across the portal —
// solid surfaces instead of heavy gradients/glass, moderate rounding instead
// of rounded-2xl everywhere, no hover:scale bounce, restrained shadows.
export const ui = {
  pageTitle: 'text-xl sm:text-2xl font-semibold text-gray-900 dark:text-white',
  pageSubtitle: 'text-sm text-gray-500 dark:text-gray-400 mt-0.5',

  card: 'bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-200',

  input:
    'w-full px-3 py-2 bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-600 rounded-lg text-sm text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/40 focus:border-indigo-500 transition-all duration-150',
  label: 'block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5',

  iconBtn:
    'inline-flex items-center justify-center p-2 rounded-lg text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-gray-700 dark:hover:text-gray-200 active:scale-90 transition-all duration-150 disabled:opacity-50 disabled:cursor-not-allowed',

  tableHeadCell: 'px-4 py-2.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide',
  tableRow: 'hover:bg-gray-50 dark:hover:bg-gray-700/40 transition-colors',
  avatar: 'w-9 h-9 rounded-lg flex items-center justify-center shrink-0 text-white font-semibold text-sm',
};

export const BADGE_TONE = {
  success: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400',
  info: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400',
  warning: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400',
  danger: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400',
  neutral: 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300',
  violet: 'bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-400',
};

export const AVATAR_TONE = {
  violet: 'bg-violet-600',
  blue: 'bg-blue-600',
  green: 'bg-emerald-600',
  orange: 'bg-orange-600',
  red: 'bg-red-600',
  gray: 'bg-gray-500',
};
